import { Navigate, Outlet } from 'react-router';
import { DataProvider } from '../data/DataProvider';
import { useSession } from './auth/session';
import { LoadingScreen } from './shell/StatusScreens';

export function RequireSession() {
  const { status, user } = useSession();
  if (status === 'loading') return <LoadingScreen />;
  if (!user) return <Navigate to="/sign-in" replace />;
  return (
    <DataProvider userId={user.id}>
      <Outlet />
    </DataProvider>
  );
}
